import { render, staticRenderFns } from "./LPDataTableThead.vue?vue&type=template&id=7c008ce5&"
import script from "./LPDataTableThead.vue?vue&type=script&lang=js&"
export * from "./LPDataTableThead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports